import { render, staticRenderFns } from "./refund2.vue?vue&type=template&id=6b58f91e&scoped=true"
import script from "./refund2.vue?vue&type=script&lang=js"
export * from "./refund2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b58f91e",
  null
  
)

export default component.exports